import React from "react";

const DashboardPagesLayout = ({
  pageTitle,
  subTitle,
  count,
  children,
  className,
  showBtn = false,
  buttonText,
  handleSubmit,
  rightHeaderContent
}) => {
  return (
    <div className={`dashboardCardContainer `}>
      <div className="px-4 py-3 d-flex justify-content-between align-center">
        <div className="text-left">
          <h4 className=" font-weight-700 m-0">{pageTitle}</h4>
          {pageTitle !== "Cashback" ? (
            <p className=" text-muted">
              {count} {subTitle}
            </p>
          ) : (
            <p className=" text-muted">
              You Crrently hold{" "}
              <span className="text-success font-weight-700"> ${count} </span>
              in cashback credits!You may use cashback towards your next
              purchase.
            </p>
          )}
        </div>
        <div className="text-right d-flex align-items-center gap-3">
          {rightHeaderContent}
          {showBtn ? <button onClick={() => handleSubmit()} className="btn btn-success">{buttonText}</button> : <></>}
        </div>
      </div>
      <hr className=" m-0" />
      <div>{children}</div>
    </div>
  );
};

export default DashboardPagesLayout;
